import { translateWebMessage, translateWebSource } from "./messages";
import type { WebMessageKey, WebMessageValues } from "./messages";
import { TIANJI_MESSAGES } from "./tianji";

export function uiText(source: string): string {
  const translated = translateWebSource("zh-CN", source);
  return translated === source ? (TIANJI_MESSAGES[source] ?? source) : translated;
}

export function uiMessage(key: WebMessageKey, values?: WebMessageValues): string {
  return translateWebMessage("zh-CN", key, values);
}
